export default class UnleashLoadingError extends Error {
  /**
   * 
   * @param {Error} error 
   */
  constructor(error: { message: string; response?: { status: number } }) {
    super(`UNLEASH_FLAGS_FETCH_ERROR: ${error.message}`);
    this.name = 'UnleashLoadingError';
  }
}